// extracted by css-extract-rspack-plugin
export default {"container":"container-jWntZ0","dot":"dot-k5SXzE","divider":"divider-E4GNVS","truncation":"truncation-P1FxRL"};